// Angular-Packages
import {BrowserModule} from '@angular/platform-browser';
import {EventEmitter, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {environment} from '../environments/environment';
import {EditorModule, TINYMCE_SCRIPT_SRC} from '@tinymce/tinymce-angular';
// Excon-Packages V2
import {ExcCoreModule} from 'exc-core-v2';
import {ExcRestMode, ExcRestModule, ExcRestService, ExcTranslateService} from 'exc-rest-v2';
import {ExcSecurityModule, ExcStateSecurityProcessor} from 'exc-security-v2';
import {ExcControlsModule, ExgModalService, ExgModalSimpleComponent, ExgWidgetService} from 'exc-controls-v2';
import {ExcSigninUiModule} from 'exc-signin-ui-v2';
import {ExcTabModule} from 'exc-tab-v2';
import {ExcUploadV2Module} from 'exc-upload-v2';
// ../src
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {DashboardComponent} from './dashboard/dashboard.component';
// Receipt
import {ReceiptDetailsComponent} from './receipt/drawer/receipt-details.component';
import {ReceiptFileUploadComponent} from './receipt/modal/receipt-file-upload.component';
import {AnnotationTextComponent} from './receipt/annotation/annotation-text.component';
import {AnnotationCorrectionComponent} from './receipt/annotation/annotation-correction.component';
import {ReceiptReviewComponent} from './receipt/drawer/receipt-review.component';
import {ReceiptListComponent} from './receipt/receipt-list.component';
import {ReceiptCheckviewComponent} from './receipt/receipt-checkview.component';
import {ExgFilterComponent} from './misc/exg-filter/exg-filter.component';
import {OrganizationUnitBoxViewComponent} from './organization-unit-box-view/organization-unit-box-view.component';
import {ModalOrganizationUnitBoxComponent} from './modals/modal-organization-unit-box/modal-organization-unit-box.component';
import {DrawerTaskDetailsComponent} from './task/drawer/drawer-task-details.component';
import {TaskListComponent} from './task/task-list/task-list.component';
import {TaskWorkspaceComponent} from './task/task-workspace/task-workspace.component';
import {CaseListComponent} from './case/case-list/case-list.component';
import {DrawerCaseDetailsComponent} from './case/drawer/drawer-case-details/drawer-case-details.component';
import {TabMessageNewFortaskComponent} from './message/tab/tab-message-new-fortask/tab-message-new-fortask.component';
import {TabMessageNewForcaseComponent} from './message/tab/tab-message-new-forcase/tab-message-new-forcase.component';
import {ExgDropdownComponent} from './misc/exg-dropdown/exg-dropdown.component';
import {ExgChartComponent} from './misc/exg-chart/exg-chart.component';
import {ChartsModule} from 'ng2-charts';
import {ModalNoteEditComponent} from './note/modal/modal-note-edit/modal-note-edit.component';
import {CdkTreeModule} from '@angular/cdk/tree';
import {ModalHistoryComponent} from './history/modal/modal-history/modal-history.component';
import {ModalTaskWorklistComponent} from './modals/modal-task-worklist/modal-task-worklist.component';
import {ModalNewTaskComponent} from './task/modal/modal-new-task/modal-new-task.component';
import {
  ModalMessageContactSelectorComponent
} from './message/modal/modal-message-contact-selector/modal-message-contact-selector.component';
import {ModalCoEditorComponent} from './modals/modal-co-editor/modal-co-editor.component';
import {CompanyComponent} from './company/company.component';
import {ReceiptCompanyListComponent} from './company/modal/receipt-company-list.component';
import {
  ModalMessageAttachmentSelectorComponent
} from './message/modal/modal-message-attachment-selector/modal-message-attachment-selector.component';
import {ModalAttachmentUploadComponent} from './modals/modal-attachment-upload/modal-attachment-upload.component';
import {ModalAttachmentUpdateComponent} from './modals/modal-attachment-update/modal-attachment-update.component';
import {ModalDialogueQuestionsComponent} from './modals/modal-dialogue-questions/modal-dialogue-questions.component';
import {ModalNewTaskWorklistComponent} from './modals/modal-new-task-worklist/modal-new-task-worklist.component';
import {CompanyListComponent} from './company/company-list.component';
import {CompanyChartComponent} from './company/company-chart/company-chart.component';
import {CompanyChartTypesComponent} from './company/company-chart/company-chart-types.component';
import {TabMessageReadComponent} from './message/tab/tab-message-read/tab-message-read.component';
import {TabMessageAnswerForwardComponent} from './message/tab/tab-message-answer-forward/tab-message-answer-forward.component';
import {ModalImageViewerComponent} from './modals/modal-image-viewer/modal-image-viewer.component';
import {CaseSelectComponent} from './workflow/case-select/case-select.component';
import {WorkflowDispositionComponent} from './workflow/workflow-disposition/workflow-disposition.component';
import {PdfViewerModule as NG2PDFViewerModule} from 'ng2-pdf-viewer';
import {CommentaryModalComponent} from './modals/commentary-modal/commentary-modal.component';
import {CommentaryBoxComponent} from './modals/commentary-modal/commentary-box/commentary-box.component';
import {ExgTextareaInputComponent} from './misc/exg-textarea-input/exg-textarea-input.component';
import {CommentaryEntryComponent} from './modals/commentary-modal/commentary-box/commentary-entry/commentary-entry.component';
import {ReceiptCollectionCheckviewViewerComponent} from './receipt/receipt-collection-checkview-viewer.component';
import {HomeComponent} from './home/home.component';
import {MessageListComponent} from './message/message-list/message-list.component';
import {ReportListComponent} from './report/report-list/report-list.component';
import {TodoListComponent} from './todo/todo-list/todo-list.component';
import {ScheduleListComponent} from './schedule/schedule-list/schedule-list.component';
import {HomeListAblaufplanpunkteComponent} from './home/card/home-list-ablaufplanpunkte.component';
import {ViewerComponent} from './reference/viewer.component';
import {ReceiptListItemComponent} from './receipt/template/receipt-list-item.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ViewerFolderFormComponent} from './reference/viewer-folder-form.component';
import {ExgFilterChipsComponent} from './misc/exg-filter-chips/exg-filter-chips.component';
import {WorkflowComponent} from './workflow/workflow.component';
import {LayoutdesignerComponent} from './layoutdesigner/layoutdesigner.component';
import {LayoutTableComponent} from './layoutdesigner/tabs/layout-table.component';
import {LayoutFilterComponent} from './layoutdesigner/tabs/layout-filter.component';
import {ExcMapV2Module} from 'exc-map-v2';
import {CaseWorkspaceComponent} from './case/case-workspace/case-workspace.component';
import {DispositionMapComponent} from './disposition/disposition-map/disposition-map.component';
import {ExcPdfviewerComponent} from './misc/exc-pdfviewer/exc-pdfviewer.component';
import {DispositionListComponent} from './disposition/disposition-list/disposition-list.component';
import {DispositionMap2Component} from './disposition/disposition-map2/disposition-map2.component';
import {SvOeDasboardComponent} from './oe/subviews/sv-oe-dasboard/sv-oe-dasboard.component';
import {
  ExcWidgetsV2Module,
  ExgAchievementComponent,
  ExgDbCircleComponent,
  ExgDbCompareComponent,
  ExgDbDoughnutComponent,
  ExgDbGroupbarComponent,
  ExgDbHorizontalBarComponent,
  ExgDbIconicComponent,
  ExgDbIndexbarComponent,
  ExgDbListComponent,
  ExgDbListSumComponent,
  ExgDbVerticalbarComponent,
} from 'exc-widgets-v2';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {UserListComponent} from './user/user-list/user-list.component';
import {SvUserProfileComponent} from './user/subviews/sv-user-profile.component';
import {SvUserDispositionsettingsComponent} from './user/subviews/widget/sv-user-dispositionsettings/sv-user-dispositionsettings.component';
import {SvUserScoringComponent} from './user/subviews/widget/sv-user-scoring/sv-user-scoring.component';
import {SvUserScoringQuestionareComponent} from './user/subviews/widget/sv-user-scoring-questionare/sv-user-scoring-questionare.component';
import {SvUserTextvorlagenComponent} from './user/subviews/widget/sv-user-textvorlagen/sv-user-textvorlagen.component';
import {SvUserStempelComponent} from './user/subviews/widget/sv-user-stempel/sv-user-stempel.component';
import {
  AnnotationService,
  BookmarkViewService,
  FormDesignerService,
  FormFieldsService,
  LinkAnnotationService,
  MagnificationService,
  NavigationService,
  PdfViewerModule,
  PrintService,
  TextSearchService,
  TextSelectionService,
  ThumbnailViewService,
  ToolbarService
} from '@syncfusion/ej2-angular-pdfviewer';
import {LayoutViewsComponent} from './layoutdesigner/tabs/layout-views.component';
import {LayoutSortComponent} from './layoutdesigner/tabs/layout-sort.component';
import {LayoutChangeViewComponent} from './layoutdesigner/modal/layout-change-view.component';
import {ExgUsersettingsComponent} from './misc/exg-usersettings/exg-usersettings.component';
import {ModalChangePasswortComponent} from './modals/modal-change-password/modal-change-password.component';
import {ModalChangeProfilpicComponent} from './modals/modal-change-profilpic/modal-change-profilpic.component';
import {ModalUserScoringEditComponent} from './user/modal/modal-user-scoring-edit/modal-user-scoring-edit.component';
import {ModalAbsencePickerComponent} from './user/modal/modal-absence-picker/modal-absence-picker.component';
import {ModalRegionRouteEditorComponent} from './user/modal/modal-region-route-editor/modal-region-route-editor.component';
import {ModalTaskStateChangeComponent} from './task/modal/modal-task-state-change/modal-task-state-change.component';
import {OverlayFileManagementComponent} from './task/overlay-file-management/overlay-file-management.component';
import {FileOverviewComponent} from './task/overlay-file-management/widget/file-overview.component';
import {ModalFilePdfEditorComponent} from './task/overlay-file-management/modal/modal-file-pdf-editor.component';
import {ReceiptObjectEditorComponent} from './receipt/modal/receipt-object-editor.component';
import {FileReceiptComponent} from './task/overlay-file-management/widget/file-receipt.component';
import {ExcPdfviewerv2Component} from './misc/exc-pdf-viewer-v2/exc-pdfviewer-v2.component';
import {ReceiptCommentNextComponent} from './receipt/modal/receipt-comment-next.component';
import {TabTaskFlowtableComponent} from './task/drawer/tab-task-flowtable.component';
import {TabTaskAttachmentComponent} from './task/drawer/tab-task-attachment.component';
import {UserAbsenceOverviewComponent} from './user/user-absence-overview/user-absence-overview.component';
import {ExgSortHeaderTableComponent} from './misc/exg-sort-header-table/exg-sort-header-table.component';
import {TabTaskReceiptComponent} from './task/drawer/tab-task-receipt.component';
import {TabTaskLeistungComponent} from './task/drawer/tab-task-leistung.component';
import {LeistungserfassungListComponent} from './leistungserfassung/leistungserfassung-list.component';
import {LeistungserfassungCheckviewComponent} from './leistungserfassung/leistungserfassung-checkview.component';
import {ModalLeistungStateChangeComponent} from './leistungserfassung/modal/modal-leistung-state-change.component';
import {ModalLeistungPositionComponent} from './leistungserfassung/modal/modal-leistung-position.component';
import {ModalLeistungPositionInfoComponent} from './leistungserfassung/modal/modal-leistung-position-info.component';
import {ModalLeistungNameComponent} from './leistungserfassung/modal/modal-leistung-name.component';
import {ReceiptFileReplaceUploadComponent} from './receipt/modal/receipt-file-replace-upload.component';
import {ReceiptReportComponent} from './receipt/modal/receipt-report.component';
import {ModalDetailHistoryComponent} from './modals/modal-detail-history/modal-detail-history.component';
import {RedirectComponent} from './redirect/redirect.component';
import {LibraryComponent} from './library/library.component';
import {ModalUploadFileComponent} from './library/Modals/modal-upload-file/modal-upload-file.component';
import {ModalLibraryInfoComponent} from './library/Modals/modal-library-info/modal-library-info.component';
import {ModalCreateLibraryComponent} from './library/Modals/modal-create-library/modal-create-library.component';
import {ExgTooltipDirective} from './directive/exg-tooltip.directive';
import {SettingsMainComponent} from './settings/settings-main/settings-main.component';
import {TabSettingsGlobalComponent} from './settings/tab/tab-settings-global/tab-settings-global.component';
import {TabSettingsAutotextComponent} from './settings/tab/tab-settings-autotext/tab-settings-autotext.component';
import {TabSettingsDefaultmessageComponent} from './settings/tab/tab-settings-defaultmessage/tab-settings-defaultmessage.component';
import {TabSettingsDocumentlibraryComponent} from './settings/tab/tab-settings-documentlibrary/tab-settings-documentlibrary.component';
import {TabSettingsFormsComponent} from './settings/tab/tab-settings-forms/tab-settings-forms.component';
import {TabSettingsQuestionsComponent} from './settings/tab/tab-settings-questions/tab-settings-questions.component';
import {TabSettingsScheduleTemplateComponent} from './settings/tab/tab-settings-schedule-template/tab-settings-schedule-template.component';
import {OeListComponent} from './oe/oe-list.component';
import {OeDetailsComponent} from './oe/tab/oe-details/oe-details.component';
import {ModalPdfViewerComponent} from './modals/modal-pdf-viewer/modal-pdf-viewer.component';
import {ModalTaskStateChangeCommentComponent} from './task/modal/modal-task-state-change-comment/modal-task-state-change-comment.component';
import {ModalCaseStateChangeCommentComponent} from './case/modal/modal-case-state-change-comment/modal-case-state-change-comment.component';
import {ModalAttachmentViewerComponent} from './Questionnaire/Templates/modal-attachment-viewer/modal-attachment-viewer.component';
import {ExgObjectListComponent} from './Questionnaire/Templates/exg-object-list/exg-object-list.component';
import {ExgFormSubmitComponent} from './Questionnaire/Templates/exg-form-submit/exg-form-submit.component';
import {QuestionnaireRendererComponent} from './Questionnaire/questionnaire-renderer/questionnaire-renderer.component';
import {NgxMaskModule} from 'ngx-mask';
import {ModalNewSettingsAutotextComponent} from './settings/tab/tab-settings-autotext/modals/modal-new-settings-autotext.component';
import {ModalChooseOEComponent} from './modals/modal-choose-oe/modal-choose-oe.component';
import {ModalQuestionnaireVersionComponent} from './task/modal/modal-questionnaire-version/modal-questionnaire-version.component';
// import {QuestionnaireEditorComponent} from './Questionnaire/questionnaire-editor/questionnaire-editor.component';
import ToolboxDataStore from './Questionnaire/questionnaire-editor/ToolboxDataStore';
import {QuestionnaireEditorComponent} from './Questionnaire/questionnaire-editor/questionnaire-editor.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {OverlayPdfEditorComponent} from './misc/overlay-pdf-editor/overlay-pdf-editor.component';
import {DispositionList2Component} from './disposition/disposition-list2/disposition-list2.component';
import {DispositionMap3Component} from './disposition/disposition-map3/disposition-map3.component';
import {ModalNewPdfComponent} from './misc/overlay-pdf-editor/modal/modal-new-pdf.component';
import {ExgPhotoDocumentationComponent} from './misc/exg-photo-documentation/exg-photo-documentation.component';
import {CalculationSpreadsheetComponent} from './Calculation/calculation-spreadsheet/calculation-spreadsheet.component';
import {SpreadsheetAllModule} from '@syncfusion/ej2-angular-spreadsheet';
import {ModalAssignConfirmationComponent} from './disposition/modal-assign-confirmation/modal-assign-confirmation.component';
import {OeWorkspaceComponent} from './oe/oe-workspace.component';
import {
  ModalChangeImageCommentComponent
} from './misc/exg-photo-documentation/modal/modal-change-image-comment/modal-change-image-comment.component';
import {ModalPickPageOfPDFComponent} from './misc/exg-photo-documentation/modal/modal-pick-page-of-pdf/modal-pick-page-of-pdf.component';
import {ModalOeAddressComponent} from './oe/modals/modal-oe-address.component';
import {ModalOeContactComponent} from './oe/modals/modal-oe-contact.component';
import {ModalOeQuestionnaireComponent} from './oe/modals/modal-oe-questionnaire.component';
import {CalculationVersionComponent} from './Calculation/calculation-version/calculation-version.component';
import {
  ModalChangeHeaderFooterComponent
} from './misc/exg-photo-documentation/modal/modal-change-header-footer/modal-change-header-footer.component';
import {ModalOeListComponent} from './oe/modals/modal-oe-list.component';
import {ModalImageEditorComponent} from './misc/exg-photo-documentation/modal/modal-image-editor/modal-image-editor.component';
import {ModalOeGroupListComponent} from './oe/modals/modal-oe-group-list.component';
import {ImageEditorModule} from '@syncfusion/ej2-angular-image-editor';
import {ModalFinishPhotoDocComponent} from './misc/exg-photo-documentation/modal/modal-finish-photo-doc/modal-finish-photo-doc.component';
import {ExgSelectV2Component} from './misc/exg-select-v2/exg-select-v2.component';
import {ExgSelectEnumerationComponent} from './misc/exg-select-enumeration/exg-select-enumeration.component';
import {ModalOeCalculationComponent} from './oe/modals/modal-oe-calculation.component';
import {
  ModalPreviewPhotoDocComponent
} from './misc/exg-photo-documentation/modal/modal-preview-photo-doc/modal-preview-photo-doc.component';
import {CaseCreatorComponent} from './case/case-creator/case-creator.component';
import {ExgTypeAheadInputComponent} from './misc/exg-type-ahead-input/exg-type-ahead-input.component';
import {ModalOeEditorComponent} from './oe/modals/modal-oe-editor.component';
import {CalculationTemplateComponent} from './Calculation/calculation-template/calculation-template.component';
import {ModalEnumMultipleChoiceComponent} from './modals/modal-enum-multiple-choice/modal-enum-multiple-choice.component';
import {ModalCalculationVersionComponent} from './Calculation/modals/modal-calculation-version.component';
import {ModalAttachmentUploadV2Component} from './modals/modal-attachment-upload-v2/modal-attachment-upload-v2.component';
import {ModalLocationCreateComponent} from './modals/modal-location-create/modal-location-create.component';
import {AppSearchbarComponent} from './misc/app-searchbar/app-searchbar.component';
import {ModalOeComponent} from './modals/modal-oe/modal-oe.component';
import {ModalSelectTaskComponent} from './modals/modal-select-task/modal-select-task.component';
import {ModalSelectCaseComponent} from './modals/modal-select-case/modal-select-case.component';
import {
  ModalSelectExistingCalculationComponent
} from './modals/modal-select-existing-calculation/modal-select-existing-calculation.component';
import {ModalSvUserProfileComponent} from './user/subviews/modal-sv-user-profile.component';
import {OverlayDispositionComponent} from './disposition/overlay-disposition/overlay-disposition.component';
import {OverlayEmlViewerComponent} from './task/overlay-eml-viewer/overlay-eml-viewer.component';
import {AppExgAdaptiveHeightDirective} from './directive/app-exg-adaptive-height.directive';
import {ReceiptDuplicatesCheckComponent} from './receipt/modal/receipt-duplicates-check.component';
import {CaseWorkspaceV2Component} from './case/case-workspace-v2/case-workspace-v2.component';
import {TaskWorkspaceV2Component} from './task/task-workspace-v2/task-workspace-v2.component';
import {ReportDocBuilderComponent} from './reportbuilder/report-doc-builder/report-doc-builder.component';
import {ReportDocSelectorComponent} from './reportbuilder/report-doc-selector/report-doc-selector.component';
import {ReportDocArrangerComponent} from './reportbuilder/report-doc-arranger/report-doc-arranger.component';
import {OverlayReportPreviewComponent} from './reportbuilder/overlay-report-preview/overlay-report-preview.component';
import {ReportDocResultComponent} from './reportbuilder/report-doc-result/report-doc-result.component';
import {TabReportDetailsComponent} from './task/drawer/tab-report-details/tab-report-details.component';
import {
  ModalConfirmReportStateChangeComponent
} from './modals/modal-confirm-report-state-change/modal-confirm-report-state-change.component';
import {ModalContactAttemptComponent} from './modals/modal-contact-attempt/modal-contact-attempt.component';
import {ExgInputV2Component} from './misc/exg-input-v2/exg-input-v2.component';
import {CaseGdvReceiptComponent} from './case/drawer/case-gdv-receipt.component';
import {ModalGdvReceiptComponent} from './modals/modal-gdv-receipt/modal-gdv-receipt.component';
import {ModalCalculationVersionExportComponent} from './Calculation/modals/modal-calculation-version-export.component';
import {ModalCalculationSignatureComponent} from './modals/modal-calculation-signature/modal-calculation-signature.component';
import {ExgSignatureComponent} from './misc/exg-signature/exg-signature.component';
import {AppExgDirectUploadV2Directive} from './directive/app-exg-direct-upload-v2.directive';
import {ModalVnDataComponent} from './modals/modal-vn-data/modal-vn-data.component';
import {ReceiptStatementCheckviewComponent} from './receipt-statement/receipt-statement-checkview.component';
import {ReceiptStatementDetailsComponent} from './receipt-statement/receipt-statement-details/receipt-statement-details.component';
import {ReceiptStatementListComponent} from './receipt-statement/receipt-statement-list.component';
import {EmlViewerComponent} from './misc/eml-viewer/eml-viewer.component';
import {ExcPdfviewerv3Component} from './misc/exc-pdf-viewer-v3/exc-pdfviewerv3.component';
import {FormularVersionComponent} from './formular/formular-version.component';
import {FormularTemplateComponent} from './formular/formular-template.component';
import {ModalFormularVersionComponent} from './formular/modal/modal-formular-version.component';
import {ModalOEFormularTemplateComponent} from './oe/modals/modal-oe-formular-template.component';
import {TabTaskFormularComponent} from './task/drawer/tab-task-formular.component';
import {ExgTabV2Component} from './misc/exg-tab-v2/exg-tab-v2.component';
import {ExcVideoViewerComponent} from './misc/exc-video-viewer/exc-video-viewer.component';
import {ReceiptFileAddUploadComponent} from './receipt/modal/receipt-file-add-upload.component';
import {ModalFileToReceiptComponent} from './task/overlay-file-management/modal/modal-file-to-receipt.component';

const Widgets = [
  ModalAssignConfirmationComponent,
  ReceiptCompanyListComponent,
  ExgModalSimpleComponent,
  ReceiptReviewComponent,
  ReceiptFileUploadComponent,
  ReceiptCheckviewComponent,
  AnnotationTextComponent,
  AnnotationCorrectionComponent,
  ModalOrganizationUnitBoxComponent,
  TabMessageNewFortaskComponent,
  TabMessageNewForcaseComponent,
  ModalNoteEditComponent,
  ModalHistoryComponent,
  ModalTaskWorklistComponent,
  ModalVnDataComponent,
  ModalMessageContactSelectorComponent,
  ModalCoEditorComponent,
  ModalMessageAttachmentSelectorComponent,
  ModalAttachmentUploadComponent,
  ModalAttachmentUpdateComponent,
  ModalDialogueQuestionsComponent,
  ModalNewTaskWorklistComponent,
  ModalNewTaskComponent,
  TabMessageReadComponent,
  ModalImageViewerComponent,
  CaseSelectComponent,
  WorkflowDispositionComponent,
  CommentaryModalComponent,
  CommentaryBoxComponent,
  ExgDbCircleComponent,
  ExgDbDoughnutComponent,
  ExgDbCompareComponent,
  ExgDbGroupbarComponent,
  ExgDbIconicComponent,
  ExgDbIndexbarComponent,
  ExgDbListComponent,
  ExgDbVerticalbarComponent,
  ExgAchievementComponent,
  ExgDbHorizontalBarComponent,
  ExgDbListSumComponent,
  SvOeDasboardComponent,
  UserListComponent,
  SvUserProfileComponent,
  SvUserDispositionsettingsComponent,
  SvUserScoringComponent,
  SvUserScoringQuestionareComponent,
  SvUserTextvorlagenComponent,
  SvUserStempelComponent,
  LayoutChangeViewComponent,
  ExgUsersettingsComponent,
  ModalChangePasswortComponent,
  ModalChangeProfilpicComponent,
  ModalUserScoringEditComponent,
  ModalAbsencePickerComponent,
  ModalRegionRouteEditorComponent,
  ModalTaskStateChangeComponent,
  OverlayFileManagementComponent,
  FileOverviewComponent,
  ModalFilePdfEditorComponent,
  ReceiptObjectEditorComponent,
  FileReceiptComponent,
  ReceiptCommentNextComponent,
  UserAbsenceOverviewComponent,
  ReceiptFileReplaceUploadComponent,
  ReceiptReportComponent,
  ModalDetailHistoryComponent,
  ModalUploadFileComponent,
  ModalLibraryInfoComponent,
  ModalCreateLibraryComponent,
  ModalPdfViewerComponent,
  ModalLeistungStateChangeComponent,
  ModalLeistungPositionComponent,
  ModalLeistungPositionInfoComponent,
  ModalLeistungNameComponent,
  ModalTaskStateChangeCommentComponent,
  ModalCaseStateChangeCommentComponent,
  WorkflowComponent,
  ModalAttachmentViewerComponent,
  ModalChooseOEComponent,
  ModalQuestionnaireVersionComponent,
  QuestionnaireEditorComponent,
  ModalNewSettingsAutotextComponent,
  OverlayPdfEditorComponent,
  DispositionList2Component,
  DispositionMap3Component,
  ModalNewPdfComponent,
  ModalChangeImageCommentComponent,
  ModalPickPageOfPDFComponent,
  ModalOeQuestionnaireComponent,
  ModalOeContactComponent,
  ModalOeAddressComponent,
  CalculationVersionComponent,
  ModalChangeHeaderFooterComponent,
  ModalOeListComponent,
  ModalImageEditorComponent,
  ModalOeGroupListComponent,
  ModalFinishPhotoDocComponent,
  ModalOeCalculationComponent,
  ModalPreviewPhotoDocComponent,
  CaseCreatorComponent,
  ExgTypeAheadInputComponent,
  ModalOeEditorComponent,
  ModalEnumMultipleChoiceComponent,
  ModalCalculationVersionComponent,
  ModalAttachmentUploadV2Component,
  ModalLocationCreateComponent,
  ModalOeComponent,
  ModalSelectTaskComponent,
  ModalSelectCaseComponent,
  ModalSelectExistingCalculationComponent,
  OverlayDispositionComponent,
  OverlayEmlViewerComponent,
  ModalSvUserProfileComponent,
  ReceiptDuplicatesCheckComponent,
  ReportDocBuilderComponent,
  ReportDocSelectorComponent,
  ReportDocArrangerComponent,
  OverlayReportPreviewComponent,
  ReportDocResultComponent,
  ModalConfirmReportStateChangeComponent,
  ModalContactAttemptComponent,
  ModalGdvReceiptComponent,
  ModalCalculationVersionExportComponent,
  ModalCalculationSignatureComponent,
  ModalFormularVersionComponent,
  ModalOEFormularTemplateComponent,
  ExcVideoViewerComponent,
  ReceiptFileAddUploadComponent,
  ModalFileToReceiptComponent
];

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ReceiptListComponent,
    ReceiptCheckviewComponent,
    ReceiptFileUploadComponent,
    ViewerComponent,
    ReceiptDetailsComponent,
    AnnotationTextComponent,
    HomeListAblaufplanpunkteComponent,
    AnnotationCorrectionComponent,
    CaseListComponent,
    CaseGdvReceiptComponent,
    CaseWorkspaceComponent,
    ExgFilterComponent,
    OrganizationUnitBoxViewComponent,
    ModalOrganizationUnitBoxComponent,
    DrawerCaseDetailsComponent,
    DrawerTaskDetailsComponent,
    TaskListComponent,
    TaskWorkspaceComponent,
    TabMessageNewFortaskComponent,
    TabMessageNewForcaseComponent,
    ExgDropdownComponent,
    ExgChartComponent,
    ModalNoteEditComponent,
    ModalHistoryComponent,
    ModalTaskWorklistComponent,
    ModalVnDataComponent,
    ModalNewTaskComponent,
    ModalMessageContactSelectorComponent,
    ModalCoEditorComponent,
    CompanyComponent,
    ReceiptCompanyListComponent,
    ModalMessageAttachmentSelectorComponent,
    ModalAttachmentUploadComponent,
    ModalAttachmentUpdateComponent,
    ModalDialogueQuestionsComponent,
    ModalNewTaskWorklistComponent,
    CompanyListComponent,
    CompanyChartComponent,
    CompanyChartTypesComponent,
    TabMessageReadComponent,
    TabMessageAnswerForwardComponent,
    ModalImageViewerComponent,
    CaseSelectComponent,
    WorkflowDispositionComponent,
    CommentaryModalComponent,
    CommentaryBoxComponent,
    ExgTextareaInputComponent,
    CommentaryEntryComponent,
    ReceiptCollectionCheckviewViewerComponent,
    HomeComponent,
    MessageListComponent,
    ReportListComponent,
    TodoListComponent,
    ScheduleListComponent,
    ReceiptListItemComponent,
    ViewerFolderFormComponent,
    ExgFilterChipsComponent,
    WorkflowComponent,
    LayoutdesignerComponent,
    LayoutTableComponent,
    LayoutFilterComponent,
    DispositionMapComponent,
    ExcPdfviewerComponent,
    DispositionListComponent,
    DispositionMap2Component,
    SvOeDasboardComponent,
    UserListComponent,
    SvUserProfileComponent,
    SvUserDispositionsettingsComponent,
    SvUserScoringComponent,
    SvUserScoringQuestionareComponent,
    SvUserTextvorlagenComponent,
    SvUserStempelComponent,
    LayoutViewsComponent,
    LayoutSortComponent,
    LayoutChangeViewComponent,
    ExgUsersettingsComponent,
    ModalChangePasswortComponent,
    ModalChangeProfilpicComponent,
    ModalUserScoringEditComponent,
    ModalAbsencePickerComponent,
    ModalRegionRouteEditorComponent,
    ModalTaskStateChangeComponent,
    OverlayFileManagementComponent,
    FileOverviewComponent,
    ModalFilePdfEditorComponent,
    ReceiptObjectEditorComponent,
    FileReceiptComponent,
    ReceiptReviewComponent,
    ExcPdfviewerv2Component,
    ReceiptCommentNextComponent,
    TabTaskFlowtableComponent,
    TabTaskAttachmentComponent,
    UserAbsenceOverviewComponent,
    ExgSortHeaderTableComponent,
    TabTaskReceiptComponent,
    TabTaskLeistungComponent,
    LeistungserfassungListComponent,
    LeistungserfassungCheckviewComponent,
    ModalLeistungStateChangeComponent,
    ModalLeistungPositionComponent,
    ModalLeistungPositionInfoComponent,
    ModalLeistungNameComponent,
    ReceiptFileReplaceUploadComponent,
    ReceiptReportComponent,
    ModalDetailHistoryComponent,
    RedirectComponent,
    LibraryComponent,
    ModalUploadFileComponent,
    ModalLibraryInfoComponent,
    ModalCreateLibraryComponent,
    SettingsMainComponent,
    TabSettingsGlobalComponent,
    TabSettingsAutotextComponent,
    TabSettingsDefaultmessageComponent,
    TabSettingsDocumentlibraryComponent,
    TabSettingsScheduleTemplateComponent,
    TabSettingsFormsComponent,
    TabSettingsQuestionsComponent,
    ModalCreateLibraryComponent,
    ExgTooltipDirective,
    OeListComponent,
    OeDetailsComponent,
    ModalPdfViewerComponent,
    ModalTaskStateChangeCommentComponent,
    ModalCaseStateChangeCommentComponent,
    // Questionnaire
    QuestionnaireRendererComponent,
    ExgFormSubmitComponent,
    ExgObjectListComponent,
    ModalAttachmentViewerComponent,
    ModalQuestionnaireVersionComponent,
    QuestionnaireEditorComponent,
    // QuestionnaireEnd
    ModalNewSettingsAutotextComponent,
    ModalChooseOEComponent,
    OverlayPdfEditorComponent,
    DispositionMap3Component,
    DispositionList2Component,
    ModalNewPdfComponent,
    ExgPhotoDocumentationComponent,
    CalculationSpreadsheetComponent,
    ModalAssignConfirmationComponent,
    OeWorkspaceComponent,
    ModalChangeImageCommentComponent,
    ModalPickPageOfPDFComponent,
    ModalOeAddressComponent,
    ModalOeContactComponent,
    ModalOeQuestionnaireComponent,
    CalculationVersionComponent,
    ModalChangeHeaderFooterComponent,
    ModalOeListComponent,
    ModalImageEditorComponent,
    ModalOeGroupListComponent,
    ModalFinishPhotoDocComponent,
    ExgSelectV2Component,
    ExgSelectEnumerationComponent,
    ModalOeCalculationComponent,
    ModalPreviewPhotoDocComponent,
    CaseCreatorComponent,
    ExgTypeAheadInputComponent,
    ModalOeEditorComponent,
    CalculationTemplateComponent,
    ModalEnumMultipleChoiceComponent,
    ModalGdvReceiptComponent,
    ModalCalculationVersionComponent,
    ModalAttachmentUploadV2Component,
    ModalLocationCreateComponent,
    AppSearchbarComponent,
    ModalOeComponent,
    ModalSelectTaskComponent,
    ModalSelectCaseComponent,
    ModalSelectExistingCalculationComponent,
    OverlayDispositionComponent,
    OverlayEmlViewerComponent,
    ModalSvUserProfileComponent,
    AppExgAdaptiveHeightDirective,
    ReceiptDuplicatesCheckComponent,
    CaseWorkspaceV2Component,
    TaskWorkspaceV2Component,
    ReportDocBuilderComponent,
    ReportDocSelectorComponent,
    ReportDocArrangerComponent,
    OverlayReportPreviewComponent,
    ReportDocResultComponent,
    TabReportDetailsComponent,
    ModalConfirmReportStateChangeComponent,
    ModalContactAttemptComponent,
    ExgInputV2Component,
    ModalCalculationVersionExportComponent,
    ModalCalculationSignatureComponent,
    ExgSignatureComponent,
    AppExgDirectUploadV2Directive,
    ReceiptStatementCheckviewComponent,
    ReceiptStatementDetailsComponent,
    ReceiptStatementListComponent,
    EmlViewerComponent,
    ExcPdfviewerv3Component,
    FormularVersionComponent,
    FormularTemplateComponent,
    ModalFormularVersionComponent,
    ModalOEFormularTemplateComponent,
    TabTaskFormularComponent,
    ExgTabV2Component,
    ExcVideoViewerComponent,
    ReceiptFileAddUploadComponent,
    ModalFileToReceiptComponent
  ],
  imports: [
    SpreadsheetAllModule, PdfViewerModule, NG2PDFViewerModule, BrowserModule, HttpClientModule, EditorModule, ExcCoreModule, ExcRestModule,
    ExcSigninUiModule, ExcTabModule, FormsModule, AppRoutingModule, ExcControlsModule, ExcUploadV2Module, ExcSecurityModule,
    ChartsModule, CdkTreeModule, DragDropModule, ClipboardModule, ExcMapV2Module.forRoot({
      apiKey: 'AIzaSyCbWtm2csoYzeeYoQjsU0wJPJ5W5AmwLrA', libraries: ['drawing', 'visualization', 'places']
    }),
    ExcWidgetsV2Module, NgxChartsModule, BrowserAnimationsModule, NgxMaskModule.forRoot(), ImageEditorModule],
  entryComponents: Widgets,
  providers: [
    ExcStateSecurityProcessor, ExgWidgetService, ExgModalService,
    LinkAnnotationService, BookmarkViewService, MagnificationService, ThumbnailViewService, ToolbarService,
    NavigationService, TextSearchService, TextSelectionService, PrintService,
    AnnotationService, FormFieldsService, FormDesignerService, ToolboxDataStore, {
      provide: 'externalUrlRedirectResolver',
      useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        window.open((route.data as any).externalUrl, '_blank');
      }
    }, {provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js'}],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private excRest: ExcRestService,
              private router: Router,
              private widgets: ExgWidgetService,
              private excTranslate: ExcTranslateService) {
    widgets.Components = Widgets;
    ExcCoreModule.RegisterConfig('Environment', environment);
    ExcCoreModule.RegisterService('Router', router);
    excRest.Mode = ExcRestMode.GROOT;
    excTranslate.activate();
    ExcCoreModule.RegisterService('GlobalRefresh', new EventEmitter<any>());
    ExcCoreModule.RegisterService('StrgI', new EventEmitter<any>());
    window.addEventListener('keydown', (event) => {
      if (event.code === 'F5' && !event.ctrlKey) {
        event.stopPropagation();
        event.preventDefault();
        ExcCoreModule.Services().GlobalRefresh.emit();
      }
      if (event.code === 'F1' || (event.ctrlKey && event.key === 'i')) {
        event.stopPropagation();
        event.preventDefault();
        ExcCoreModule.Services().StrgI.emit();
      }
    });
  }
}
